export const barnTypesList = [
    "Boarding Barn",
    "Private Barn",
];